import {createAction} from 'redux-act';

export const GET_CASHBACK_SUMMARY = createAction(
  'cashback/GET_CASHBACK_SUMMARY'
);
export const GET_CASHBACK_SUMMARY_SUCCESS = createAction(
  'cashback/GET_CASHBACK_SUMMARY_SUCCESS'
);
export const GET_CASHBACK_SETTINGS = createAction(
  'cashback/GET_CASHBACK_SETTINGS'
);
export const GET_CASHBACK_SETTINGS_SUCCESS = createAction(
  'cashback/GET_CASHBACK_SETTINGS_SUCCESS'
);
export const SAVE_CASHBACK_SETTINGS = createAction(
  'cashback/SAVE_CASHBACK_SETTINGS'
);
export const SET_CASHBACK_SETTINGS_LOADING = createAction(
  'cashback/SET_CASHBACK_SETTINGS_LOADING'
);
export const SET_LOADING = createAction('cashback/SET_LOADING');
export const CLEAR_CASHBACK_DATA = createAction('cashback/CLEAR_CASHBACK_DATA');
